import React, { useState, useEffect } from 'react';
import { DatePicker, Input, Image as AntdImage, Tooltip, Tag } from 'antd';
import { CaretDownOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment';

import Iconfont from "../../../../components/Iconfont/Iconfont";
import dateIcon from "../../../../assets/img/V7/dateIcon.svg";
import Api from "../../../../api";
import "./index.scss";

const { RangePicker } = DatePicker;
const Ministry = ({
    ministryHtml,
    callBack,
    searchData,
    id,
    countryDeptList
}) => {
     // 政策
    const [tooltipIsOpen, setTooltipIsOpen] = useState(false); // 控制选择地区/部委弹窗是否显示
    const [ministriesList, setMinistriesList] = useState([]);
    const [selectedMinistriesList, setSelectedMinistriesList] = useState([]); // 选择的部委
    const [selectedMinistries, setSelectedMinistries] = useState([]); // 选择的部委对象

    useEffect(() => { 
        getMinistriesList();
    }, [])

    useEffect(()=>{
        setSelectedMinistriesList(searchData.countryDeptIds ? searchData.countryDeptIds : []);
        setSelectedMinistries(countryDeptList ? countryDeptList : []);
    },[searchData.countryDeptIds])

    const getMinistriesList = async() => {
        // 0 国务院 1 部委
        try {
            let res = await Api.Common.getDepartments({data:{type:1}});
            if(res && res.code === 0 && res.data){
                setMinistriesList(res.data[0].childList || [])
            }else{}
        } catch (errInfo) {
            console.log('验证失败:', errInfo);
        }
    }

    // 政策弹窗-选中
    const renderDepartmentList = (selectedCodes) => {
        let allCodeList = [], allList = [];
        ministriesList.forEach(item => {
            const departmentChildren = item.childList || [];
            departmentChildren.forEach(it => {
                allCodeList.push(it.id);
                allList.push(it);
            })
        });
        const isAllSelected = selectedCodes.length >= allCodeList.length;
        return (
            <div className="regionsPopoverBox departmentPopoverBox">
                <div className="areaListBox">
                    <span
                        className={`regionsAllArea ${isAllSelected ? "selectRegion" : ""}`}
                        onClick={()=>{
                            ministriesChange(isAllSelected ? [] : allList, isAllSelected ? [] : allCodeList)
                        }}
                    >全部部委</span>
                    <div className="regionsAllListBox">
                        {
                            ministriesList.map((item, idx) => {
                                if(item.childList.length > 0){
                                    let departmentIsAllSelected = true;
                                    const departmentCodeList = [];
                                    for (const addressItem of item.childList) {
                                        const code = addressItem.id;
                                        let flag = selectedCodes.includes(code);
                                        if (departmentIsAllSelected) {
                                            departmentIsAllSelected = flag;
                                        }
                                        departmentCodeList.push(code);
                                    }
                                    return (
                                        <div key={idx} className="regionsList">
                                            <span
                                                className={`regionsArea ${(departmentIsAllSelected || isAllSelected) ? "selectRegion":""}`}
                                                onClick={()=>{
                                                    console.log(item,departmentIsAllSelected,departmentCodeList)
                                                    let codes = [...selectedCodes], ministries = [];;
                                                    if (departmentIsAllSelected) {
                                                        departmentCodeList.forEach(code => {
                                                            let idx = codes.indexOf(code);
                                                            codes.splice(idx, 1);
                                                        })
                                                        // 删除选中
                                                        selectedMinistries.map((it,index)=>{
                                                            if(!departmentCodeList.includes(it.id)){
                                                                ministries.push(it);
                                                            }
                                                        })
                                                    } else {
                                                        departmentCodeList.forEach(code => {
                                                            if (!codes.includes(code)) {
                                                                codes.push(code);
                                                            }
                                                        })
                                                        // 选中大类型
                                                        let newDate = [...selectedMinistries,...item.childList];
                                                        ministries = newDate.filter((item, index, self) => {
                                                            return index === newDate.findIndex((obj2) => obj2.id === item.id)
                                                        });
                                                    }
                                                    ministriesChange(ministries,codes)
                                                }}
                                            >{item.name}</span>
                                            <div className="regionsBox">
                                                {
                                                    item.childList.map(it => {
                                                        const idx = selectedCodes.indexOf(it.id);
                                                        const isSelected = idx > -1;
                                                        return (
                                                            <span
                                                                key={it.id}
                                                                onClick={()=> {
                                                                    let codes = [...selectedCodes], ministries = [...selectedMinistries];
                                                                    if (isSelected) {
                                                                        codes.splice(idx, 1);
                                                                        ministries.splice(idx, 1);
                                                                    } else {
                                                                        codes.push(it.id);
                                                                        ministries.push(it);
                                                                    }
                                                                    ministriesChange(ministries,codes);
                                                                }}
                                                                className={`regionsItem ${(isSelected || departmentIsAllSelected || isAllSelected) ? "selectRegion":""}`}
                                                            >{it.name}</span>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>

                </div>
                <div className="footerOperateBox">
                    <span className="operateBtn cancelBtn" onClick={() => cancelChangeMinistries()}>取消</span>
                    <span className="operateBtn confirmBtn" onClick={() => confirmChangeMinistries(selectedMinistries,selectedMinistriesList)}>确定</span>
                </div>
            </div>
        )
    }
    const cancelChangeMinistries = () => {
        setTooltipIsOpen(false);
        ministriesChange(countryDeptList,[...(searchData.countryDeptIds || [])]);
    }

    const confirmChangeMinistries = (data,codes) => {
        setTooltipIsOpen(false);
        callBack({
            "countryDeptIds": codes || [],
            "countryDeptList": data || [],
        })
    }

    const ministriesChange = (data,codes) => {
        console.log(data,codes,"ministriesChange");
        setSelectedMinistriesList(codes);
        setSelectedMinistries(data);
    }


    return(
        <>
            <Tooltip
                open={tooltipIsOpen}
                overlayClassName={"areaOrDepartmentTooltipBox"}
                placement={"bottomRight"}
                title={(
                    <div className="areaOrDepartmentContentBox" onClick={e => e.stopPropagation()}>
                        {renderDepartmentList(selectedMinistriesList)}
                    </div>
                )}
                trigger={"click"}
                onClick={e => e?.stopPropagation()}
            >
                <div key={id} onClick={()=>setTooltipIsOpen(id)} style={{display: "inline-block"}}>
                    {ministryHtml}
                </div>
            </Tooltip>
        </>
    )
}

export default Ministry;
